module.exports = __webpack_public_path__ + "img/Spieler.2fb6fc9e.jpg";